import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import ClientSearchService from "src/services/ClientSearchService"

export const fetchVehicleTypes = createAsyncThunk(
  "vehicle/fetchVehicleTypes",
  async () => {
    const res = await ClientSearchService.GetVehiceType()
    return res.success
  }
)

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState: {
    types: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicleTypes.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchVehicleTypes.fulfilled, (state, action) => {
        state.loading = false
        state.types = action.payload
      })
      .addCase(fetchVehicleTypes.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export default vehicleSlice.reducer
